import action from '../helpers/rest-client'
import { paginationString } from '../helpers/getPaginationString'
import {
  NewElementOutDto,
  EditElementOutDto,
  DeleteElementOutDto,
  GetOneElementOutDto,
  GetAllElementsOutDto,
} from '../types/element.dto'

export class ErrorElement extends Error { }
const path = '/element'
class Element {
  public new(payload: NewElementOutDto<any>) {
    return action
      .Post({
        url: `${path}`,
        body: payload,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public edit({ idElement, body }: EditElementOutDto<any>) {
    return action
      .Put({
        url: `${path}/${idElement}`,
        body,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getAll({ filters, pagination, sort }: GetAllElementsOutDto<any>) {
    const filtersJSON = filters ? `&filters=${JSON.stringify(filters)}` : '';

    return action
      .Get({
        url: `${path}${paginationString({ pagination, sort })}${filtersJSON}`,
      })
      .then(response => {
        return { response, error: undefined }
      })
      .catch(error => {
        return { error, response: undefined }
      })
  }

  public getOne({ idElement }: GetOneElementOutDto<any>) {
    return action
      .Get({
        url: `${path}/${idElement}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public deleteOne({ idElement }: DeleteElementOutDto) {
    return action
      .Del({
        url: `${path}/${idElement}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }
}

const content = new Element()
export default content
